import React, {Component} from 'react';
import Address from '../components/address';
import SocialList from '../components/social-list.js';

class Contact extends Component {
    constructor(props) {
        super(props);

        const data = props.data;
        this.state = {
            data: data,
            email: data.email,
            tooltip: data.tooltip,
            background: data.subscribe.background,
            link: data.subscribe.link,
            address: data.address,
        };
    }

    render() {
        const section = {
            background: 'white',
            backgroundSize: 'cover',
            textAlign: 'left'
        };

        const mainContainer = {
            height: 'inherit'
        };

        const background = {
            background: `linear-gradient(rgba(0, 0, 0, 0.50), rgba(0, 0, 0, 0.15)), url(${this.state.background}) no-repeat center center`,
            backgroundSize: 'cover',
        };

        const row = {
            height: 'inherit',
        };

        const rightColumn = {
            color: 'black',
        };

        const subscribe = {
            width: '80%',
        };

        const link = {
            fontFamily: 'Avenir-Heavy',
            textDecoration: 'underline',
            fontStyle: 'normal',
        };

        const kuwait = this.state.address.KUWAIT;
        const qatar = this.state.address.QATAR;
        const dubai = this.state.address.DUBAI;
        const gcc = this.state.address.GCC;

        return (
            <div className="section fp-auto-height-responsive" data-tooltip="CONTACT" style={section}>
                <div className="container-fluid" style={mainContainer}>
                    <div className="row" style={row}>
                        <div className="col-xs-12 col-md-4 pt-5 pl-2 pr-2 d-flex flex-row justify-content-center" style={background}>
                            <h3 className="pt-5 pb-5 pl-md-4 pl-xs-2 pr-1 mt-5 mb-5" style={subscribe}>Click <a className="link-button" target="_blank" rel="noopener noreferrer" href={this.state.link} style={link}>here</a> to get a monthly dose of refined architectural wonder...</h3>
                        </div>
                        <div className="col-xs-12 col-md-8 pt-5 pl-md-5 pl-xs-3 pr-2 pb-3 d-flex flex-column justify-content-between" style={rightColumn}>
                            <SocialList color="#111111"/>
                            <div className="row p-5 mt-5">
                                <Address data={kuwait}/>
                                <Address data={dubai}/>
                                <Address data={qatar}/>
                                <Address data={gcc}/>
                                <div className="col-sm-12 col-md-6">
                                    <div className="invisible p-3"></div>
                                    <p>{this.state.email}</p>
                                </div>
                            </div>
                            <footer className="footer pt-4 pb-0 pl-4 pr-4">
                                <div className="container pt-4 pb-0 pl-4 pr-4">
                                    <p className="text-muted">2017 &copy; Nasser Mubarak Al Essa General Trading & Contracting. All rights reserved.</p>
                                </div>
                            </footer>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/contact.js